<template>
  <div
    id="communityGas_main"
    class="communityGas_main"
  >
    <div class="main">
      <TitleBar
        title="瓦斯登記列表"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/gas_log_v2_intro/',
          product_id: 'gas_log',
          product_name: '瓦斯抄表',
          subpage_name: ''
        }"
        tip="可檢視所有瓦斯登記歷史記錄"
      />
      <FilterFrame
        ref="filter"
        :filter-form="gasFilter"
        @search="search"
        @clear="clearSearch()"
      />
      <div class="title_bar center">
        <div class="left">
          <!-- 範例留用 -->
          <!-- <span class="questionnaire">喜歡這次改版嗎？<span @click="$toExternaLink('https://docs.google.com/forms/d/e/1FAIpQLSeO_OaPdVA2OMTuVFyWXZGgkOtK6haogyGsaWN-gCmXdTpXNA/viewform?usp=sf_link')">點此填寫滿意度調查！</span></span> -->
        </div>
        <div class="right">
          <span>搜尋結果共計 {{ ListData.length }} 筆</span>
          <el-button
            icon="icon-plus"
            :disabled="!disabledAddButton"
            round
            @click="addRow"
          >
            新增登記年月
          </el-button>
        </div>
      </div>
      <el-table
        class="list"
        :data="ListData"
        empty-text="目前無任何瓦斯登記記錄"
      >
        <el-table-column
          type="index"
          align="left"
          width="50"
        />
        <el-table-column
          align="left"
          label="登記年月"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="scope.row.edited"
              :ref="'ymDatePicker'+scope.$index"
              v-model="scope.row.Ym"
              type="month"
              placeholder="選擇年、月份"
              value-format="yyyy-MM"
              class="datePicker"
              :class="(needVerify && scope.row.Ym === undefined) || scope.row.Ym === null || scope.row.Ym === '' ? 'borderRed' : ''"
              @change="datePickerChange(scope.$index, scope.row.Ym )"
            />
            <router-link
              v-else
              :to="{
                name: 'CommunityGasOverView',
                params:{
                  id: scope.row.Id,
                  ym: scope.row.Ym
                }
              }"
              class="gas-title"
            >
              {{ scope.row.Ym }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          width="290"
          label="抄表起訖日"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="scope.row.edited"
              :ref="'datePicker'+scope.$index"
              v-model="scope.row.StartToDue"
              style="width: 270px"
              type="daterange"
              placeholder="選擇日期"
              :default-value="defaultDueValue"
              value-format="yyyy-MM-dd"
              :class=" (needVerify && scope.row.StartToDue === undefined)|| scope.row.StartToDue === null || (scope.row.StartToDue !== undefined && scope.row.StartToDue.length < 2) ?'borderRed':''"
            />
            <p v-else>
              {{ scope.row.StartDate ? scope.row.StartDate : '-' }} 至 {{ scope.row.DueDate }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateDate"
          align="left"
          label="更新時間"
        />
        <el-table-column
          prop="CreateUser"
          align="left"
          label="更新人員"
        />
        <el-table-column
          align="left"
          label="登記戶數"
        >
          <template slot-scope="scope">
            <span class="font_green">{{ scope.row.DetailCount }}</span>
            <span
              v-if="scope.row.TabletCount !== undefined"
              class="font"
            >／{{ scope.row.TabletCount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.edited"
              size="mini"
              plain
              @click="cancelTableRow(scope.row)"
            >
              取消
            </el-button>
            <el-button
              v-if="scope.row.edited"
              size="mini"
              type="primary"
              plain
              @click="submitTableRow(scope.row)"
            >
              送出
            </el-button>
            <el-tooltip
              effect="dark"
              content="舊期別未支援編輯"
              placement="left"
              :disabled="scope.row.StartDate !== null"
            >
              <span style="margin-right: 10px;">
                <el-button
                  v-if="!scope.row.edited"
                  size="mini"
                  plain
                  :disabled="scope.row.StartDate === null"
                  @click="editTableRow(scope.row , scope.$index)"
                >編輯</el-button>
              </span>
            </el-tooltip>
            <el-button
              v-if="!scope.row.edited"
              class="deleteButton"
              size="mini"
              type="danger"
              plain
              @click="deleteTableRow(scope.row, scope.$index)"
            >
              刪除
            </el-button>
            <el-button
              v-if="!scope.row.edited"
              class="notifyButton"
              size="mini"
              type="primary"
              :disabled="scope.row.notifyDisabled"
              plain
              @click="notifyAgain(scope.row, scope.$index)"
            >
              <span v-show="!scope.row.IsNotify">通知</span>
              <span v-show="scope.row.IsNotify">再通知</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import TitleBar from '@/components/PageTitleBar.vue'
import { setTimeout } from 'timers'

export default {
  components: {
    FilterFrame,
    TableLoading,
    TitleBar
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'CommunityGasOverView') {
      next(vm => {
        console.log(vm.$store.state.communityGas.edited)
        console.log(vm.$store.state.communityGas.height)
        if (vm.$store.state.communityGas.edited) {
          vm.initListData()
          vm.$store.commit('ifCommunityGasEdit', false)
        } else if (vm.$store.state.communityGas.height != null) {
          vm.$nextTick(() => {
            document.documentElement.scrollTop = vm.$store.state.communityGas.height
          })
        }
      })
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    // eslint-disable-next-line eqeqeq
    if (to.name != 'CommunityGasOverView') { this.$store.commit('recordCommunityGasHeight', null) } else { this.setHeight() }
    next()
  },
  data () {
    return {
      filter: '',
      gasFilter: [
        {
          label: '依年月',
          name: 'month',
          type: 'month'
        }
      ],
      ListData: [],
      offset: 0,
      loading: false,
      showInput: false,
      stopGetList: true,
      submitYear: false,
      submitDate: false,
      canClickButton: true,
      disabledAddButton: false,
      currentGasId: null,
      disabledDeleteButton: false,
      defaultDueValue: new Date(),
      gasNotifyTypeMap: {
        1: '，並已預約今日19:00推播通知住戶',
        2: '，並已預約明日19:00推播通知住戶',
        3: '，並已預約起日19:00推播通知住戶',
        4: '，並發送推播通知住戶'
      },
      needVerify: false
    }
  },
  mounted () {
    this.initListData()
    window.addEventListener('scroll', this.autoShow, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 查詢
    search (such_val) {
      if (this.canClickButton && !this.loading) {
        this.canClickButton = false
        this.filter = such_val.month === undefined ? '' : such_val.month
        this.initListData()
        window.scrollTo(0, 0)
        document.getElementById('searchButton').blur()
      }
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton && !this.loading) {
        this.canClickButton = false
        this.filter = ''
        this.initListData()
        this.loading = true
        window.scrollTo(0, 0)
        document.getElementById('clearButton').blur()
      }
    },
    async initListData () {
      this.offset = 0
      this.ListData = []
      this.stopGetList = false
      await this.getCurrentGasYm()
      await this.getList()
      this.disabledAddButton = true
    },
    // 取得當期期別
    async getCurrentGasYm () {
      this.currentGasId = null
      const response = await apiGas.List.GetCurrentGas()
      if (response.data.Data && response.data.Data.Id) {
        this.currentGasId = response.data.Data.Id
      }
    },
    // 取得列表資料
    getList () {
      this.loading = true
      this.ListData = this.offset === 0 ? [] : this.ListData
      const requestData = {
        'PageParam.Offset': this.offset,
        'PageParam.MaxCount': 10
      }
      if (this.filter !== '') { requestData['Filter.Ym'] = this.filter }
      return apiGas.List.GetGasList(
        requestData
      ).then(async (res) => {
        // 成功
        await this.$sleep(1000, res.duration)
        if (res.data.Status === 1) {
          if (res.data.Data.length !== 0) {
            this.adjustListDisplay(res.data.Data)
            this.stopGetList = !(res.data.Data.length < 10)
          } else {
            this.stopGetList = false
          }
        } else if (res.data.Status === 0) {
          console.log('可控的錯誤')
        } else {
          console.log('未知錯誤')
        }
        this.loading = false
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
        return true
      }).catch((err) => {
        console.log(err)
        this.loading = false
        return false
      })
    },
    setHeight () {
      this.$store.commit('recordCommunityGasHeight', document.documentElement.scrollTop)
    },
    // 調整列表顯示
    adjustListDisplay (data) {
      const nowDateTime = new Date(this.$formatDate(new Date())).getTime()
      data.forEach((item) => {
        const ym1 = item.Ym.toString().substr(0, 4)
        const ym2 = item.Ym.toString().substr(-2, 2)
        const newYm = ym1.concat('-', ym2)
        item.Ym = newYm
        item.DueDate = item.DueDate.substr(0, 10)
        item.StartDate = item.StartDate ? item.StartDate.substr(0, 10) : null
        item.StartToDue = [item.StartDate, item.DueDate]
        item.CreateDate = item.CreateDate.substr(0, 16)
        item.edited = false
        const dueDateTime = new Date(`${item.DueDate} 23:59:59`).getTime()
        // 已過期, 登記戶數已滿, 非當期 -> 阻擋再通知
        if (dueDateTime < nowDateTime || (item.DetailCount >= item.TabletCount) || (item.Id !== this.currentGasId)) {
          item.notifyDisabled = true
        } else {
          item.notifyDisabled = false
        }
      })
      this.ListData = this.ListData.concat(data)
      if (this.ListData.length > 10) { window.scrollTo(0, document.documentElement.scrollHeight - (document.documentElement.clientHeight * 1.2)) }
    },
    // 新增
    addRow () {
      this.disabledAddButton = false
      this.ListData.unshift({})
      this.ListData[0].edited = true
      this.$nextTick(() => {
        this.$refs.ymDatePicker0.focus()
        this.$refs.datePicker0.blur()
      })
    },
    // 刪除
    async deleteTableRow (row, index) {
      document.querySelectorAll('.deleteButton')[index].blur()
      let confirmText = ''
      if (row.DetailCount) {
        confirmText = `已有${row.DetailCount}戶完成登記，刪除後將無法復原，確認是否刪除？`
      } else {
        confirmText = '是否刪除瓦斯抄表期別？'
      }
      if (this.disabledDeleteButton) return
      this.disabledDeleteButton = true
      this.$confirm(confirmText, '', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (!this.disabledDeleteButton) return
          this.disabledDeleteButton = false
          if (action === 'confirm') {
            instance.confirmButtonDisabled = true
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '執行中...'
            this.fullScreenLoading(true)
            const queryPath = {
              id: row.Id
            }
            try {
              await apiGas.List.DeleteGas(queryPath)
              this.ListData.splice(index, 1)
              if (row.Id === this.currentGasId) {
                await this.getCurrentGasYm()
                const list = JSON.parse(JSON.stringify(this.ListData))
                this.ListData = []
                this.adjustListDisplay(list)
              }
              this.$message({
                type: 'success',
                message: '已完成刪除'
              })
            } catch (error) {
              this.fullScreenLoading(false)
              this.$alert('刪除失敗', '', {
                confirmButtonText: '確定',
                type: 'warning',
                callback: action => {}
              })
            }
            done()
            this.disabledDeleteButton = false
            instance.confirmButtonLoading = false
            instance.confirmButtonDisabled = false
            this.fullScreenLoading(false)
          } else {
            done()
          }
        }
      }).then(async () => {
        this.disabledDeleteButton = false
      }).catch(() => {
        this.disabledDeleteButton = false
      })
    },
    async notifyAgain (data, index) {
      document.querySelectorAll('.notifyButton')[index].blur()
      this.$confirm('是否要針對尚未登記的住戶發送通知？', '', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonDisabled = true
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '執行中...'
            const queryPath = {
              id: data.Id
            }
            await apiGas.List.NotifyFromRemind(queryPath)
            data.IsNotify = true
            this.$message({
              type: 'success',
              message: '通知已發送成功'
            })
            done()
            instance.confirmButtonLoading = false
            instance.confirmButtonDisabled = false
          } else {
            done()
          }
        }
      }).then(() => {

      }).catch(() => {

      })
    },
    // 編輯
    editTableRow (row, index) {
      row.edited = true
      row.copyYm = row.Ym
      row.copyDueDate = row.DueDate
      this.$nextTick(() => {
        this.$refs['ymDatePicker' + index].focus()
      })
    },
    // 取消
    cancelTableRow (row) {
      if (row.CreateDate === undefined) {
        this.disabledAddButton = true
        this.ListData.shift()
      } else {
        row.edited = false
        row.Ym = row.copyYm
        row.DueDate = row.copyDueDate
      }
      this.needVerify = false
    },
    // 送出
    async submitTableRow (row) {
      row.DueDate = row.StartToDue ? row.StartToDue[1] : null
      row.StartDate = row.StartToDue ? row.StartToDue[0] : null
      const ym = row.Ym
      const dueDate = row.DueDate
      const startDate = row.StartDate
      let alertMsg = ''
      this.needVerify = true
      if (!ym && !dueDate && !startDate) { alertMsg = '請輸入「登記年月」與「起訖日」' } else if (!ym) { alertMsg = '請輸入「登記年月」' } else if (!dueDate || !startDate) { alertMsg = '請輸入「起訖日」' } else if (new Date(dueDate) < new Date(ym)) {
        alertMsg = '「訖日」不可早於「登記年月」'
      }
      if (alertMsg) {
        this.$alert(alertMsg, '', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
        return
      }
      row.edited = false
      this.fullScreenLoading(true)
      if (row.CreateDate === undefined) { this.addGasMain(row) } else { this.updateGasMain(row) }
    },
    async addGasMain (row) {
      try {
        const { GasNotifyType } = await this.insertGasPeriod(row)
        this.initListData()
        if (GasNotifyType === 0 || GasNotifyType === 5) {
          this.$message({
            type: 'success',
            message: '瓦斯抄表期別新增成功'
          })
        } else {
          this.$alert(`瓦斯抄表期別新增成功${this.gasNotifyTypeMap[GasNotifyType]}`, '', {
            confirmButtonText: '確定',
            type: 'warning',
            callback: action => {}
          })
        }
        this.disabledAddButton = true
        this.fullScreenLoading(false)
      } catch (error) {
        console.log('error', error)
        if (error.ErrorMessage.Code === 409000) {
          this.disabledAddButton = true
          this.initListData()
        }
        this.fullScreenLoading(false)
      }
      this.needVerify = false
    },
    // 新增後送出
    async insertGasPeriod (row) {
      const requestData = {
        Ym: row.Ym.toString().substr(0, 4) + row.Ym.toString().substr(-2, 2),
        DueAt: row.DueDate + 'T23:59:59Z',
        StartAt: row.StartDate + 'T00:00:00Z'
      }
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          apiGas.List.PostGasInsertPeriod(
            requestData
          ).then(res => {
            resolve(res.data.Data)
          }).catch(err => {
            reject(err.response.data)
          })
        }, 1000)
      })
    },
    // 編輯後送出
    async updateGasMain (row) {
      const requestData = {
        Ym: row.Ym.toString().substr(0, 4) + row.Ym.toString().substr(-2, 2),
        DueAt: row.DueDate + 'T23:59:59Z',
        StartAt: row.StartDate + 'T00:00:00Z'
      }
      const queryPath = {
        id: row.Id
      }
      await this.$sleep(1000)
      try {
        const res = await apiGas.List.PostGasUpdatePeriod(
          queryPath,
          requestData
        )
        console.log(res)
        const { GasNotifyType } = res.data?.Data

        this.initListData()
        if (GasNotifyType === 0 || GasNotifyType === 5) {
          this.$message({
            type: 'success',
            message: '瓦斯抄表期別編輯成功'
          })
        } else {
          this.$alert(`瓦斯抄表期別編輯成功${this.gasNotifyTypeMap[GasNotifyType]}`, '', {
            confirmButtonText: '確定',
            type: 'warning',
            callback: action => {}
          })
        }
      } catch (err) {
        console.log(err)
        if (err.response.data.ErrorMessage.Code === 409000) {
          this.initListData()
        }
        console.log('錯誤訊息', err.response)
      }
      this.needVerify = false
      this.fullScreenLoading(false)
    },
    // 下拉到底自動載入
    autoShow () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'CommunityGas') {
        if (this.stopGetList) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料上傳中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    },
    // 失去登記年月日期選擇器焦點後，將自動 focus 到截止日期選擇器
    // 若截止日期為空則面板需顯示登記月份、而非當前月份，以避免管理員選錯日期
    // eg. 當前為 11 月，管理員登記 12 月，截止日期應顯示 12 月，而非顯示 11 月
    // 若截止日期不為空則顯示截止日期月份即可（不用調整）
    datePickerChange (index, value) {
      this.defaultDueValue = new Date(value)
      this.$nextTick(() => {
        this.$refs['datePicker' + index].focus()
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#communityGas_main
  +mainLayer
  .list
    font-size: 16px
  ::v-deep .el-table
    +basicTable
    color: $subFontColor
    .gas-title
      text-decoration: underline
      color: $mainColorDark
      font-weight: bold
      cursor: pointer
  ::v-deep .el-date-editor.datePicker
    width: 150px
    .el-input__inner
      width: 160px
      text-align: center
      font-size: 15px
    &.borderRed
      .el-input__inner
        border: $dangerColorHover 1px solid
  ::v-deep .el-date-editor.el-range-editor
    &.borderRed
      border: $dangerColorHover 1px solid

  .font_green
    color: $mainColor
    font-weight: bold

</style>
